export default {
  showLogs: false,
  showTrace: false,

  execute(method, ...params) {
    if (this.showLogs) {
      console[method](...params); // eslint-disable-line no-console
      if (this.showTrace) {
        console.groupCollapsed(`trace of ${method}`); // eslint-disable-line no-console
        console.trace(); // eslint-disable-line no-console
        console.groupEnd(); // eslint-disable-line no-console
      }
    }
  },

  log(...messages) {
    this.execute('log', ...messages);
  },
  info(...messages) {
    this.execute('info', ...messages);
  },
  warn(...messages) {
    this.execute('warn', ...messages);
  },
  error(...messages) {
    this.execute('error', ...messages);
  },
  group(...params) {
    this.execute('group', ...params);
  },
  groupCollapsed(...params) {
    this.execute('groupCollapsed', ...params);
  },
  groupEnd(...params) {
    this.execute('groupEnd', ...params);
  },
  clear(...params) {
    this.execute('clear', params);
  },
  table(params) {
    this.execute('table', params);
  },
};
